<template>
    <div id="app" :class="[isMobile ? 'mobile': '']" >
        <router-view ref="page" @login="login" @logout="logout" ></router-view>
    </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import api from './network/api.js';
//import facebook from './network/facebook.js'
import apple from './network/apple.js'
import google from './network/google.js'
import assets from './assets/AssetsConfig.js'
export default {
    data() {
        return {
            assetPath: '',
            sid: null,
            isMobile: false,
            googleClient: null
        }
    },

    created() {
        this._global.app = this;
        this.isMobile = /(iphone)|(android)|(windows phone)/i.test(navigator.userAgent);
        this._global.isMobile = this.isMobile;
        this._global.userID = localStorage.getItem("userID") || '';
        this._global.poAssets = [];
        window.onAppleIDSignIDFailed = this.loginFailed.bind(this);

        apple.appleIdInit();
        this.googleClient = google.initGoogleCodeClient(this.googleLogin.bind(this), this.loginFailed.bind(this));
        this.loadResources();
    },

    mounted() {
        if (this.$router.currentRoute.path !== '/') this.$router.replace("/");

        api.getSessionId().then(resp => {
            if (resp.data.status === 'ok') {
                this.sid = resp.data.sid;
                this._global.sid = resp.data.sid;
            }
        })
    },

    methods: {
        loadResources() {
            let preload = assets.preload;
            let list = [].concat(preload.resources).concat(this.isMobile ? preload.mobile: preload.web);
            this.loadImage(list, this.gotoLogin.bind(this));
        },
        loadImage(list, callback) {
            let total = list.length, loaded = 0;
            list.map((i) => {
                let image = new Image();
                image.onload = () => {
                    loaded++;
                    if (loaded === total) {
                        callback && callback();
                    }
                };
                image.src = this._global.assetsRoot + "/" + i;
            })
        },
        gotoLogin() {
            //let queryUserId = this.$route.query.user_id ? this.$route.query.user_id : '';
            var url = window.location.href;
            var urlObj = new URL(url);
            var queryUserId = urlObj.searchParams.get("user_id");
            //console.log(queryUserId);
            let userinfo = localStorage.getItem("userinfo");

            if(queryUserId){
                userinfo = '{"userID":"' + queryUserId + '"}';
            }
            if (!userinfo) {
                // 跳转到登录页面
                this.$router.history.current.path !== "/login" && this.$router.replace("/login");
            } else {
                // this._global.user = JSON.parse(userinfo);
                let user = JSON.parse(userinfo);
                this.guestLogin(user.userID);
                // this._i18n.locale = /(en)|(es)|(pt)/.test(this._global.user.lang) ? this._global.user.lang: 'en';
                // this.getProductsList();
            }
        },
        login(data) {
            switch(data.type) {
                case "facebook": this.facebookLogin();break;
                case "apple": this.appleLogin();break;
                case "google": this.googleClient.requestCode();break;
                case "guest": this.guestLogin(data.userID);break;
                default: break;
            }
        },
        getDynamicAppId() {
            // Replace this with your dynamic logic (API call, environment variable, etc.)
            var hostname = window.location.hostname;
            const fbAppId = hostname == 'store.drbingo.com' ? '346029962096610' : '998332483533018';
            return fbAppId;
        },
        async initFacebook() {
            this.appId = this.getDynamicAppId();
            await this.$facebookLogin.init(this.appId);
        },
        async facebookLogin() {
            /*facebook.facebookLogin((resp) => {
                console.log("facebook login:")
                console.log(resp);
                api.facebookConnect(this.sid, resp.access_token).then(this.onLogin.bind(this));
            }, this.loginFailed.bind(this))*/

            try {
                await this.initFacebook(); // Initialize with dynamic App ID
                const authResponse = await this.$facebookLogin.login();
                //const userData = await this.$facebookLogin.getUserData();
                //console.log('User Data:', userData, authResponse);
                api.facebookConnect(this.sid, authResponse.accessToken).then(this.onLogin.bind(this));
                // Handle user data here (e.g., save to server or state management)
            } catch (error) {
                console.error('Facebook Login Error:', error);
            }
        },
        appleLogin() {
            apple.appleIdSignIn().then((resp) => {
                //console.log("google login:");
                //console.log(resp);
                let decode = jwt.decode(resp.authorization.id_token);
                //console.log("decode:", decode);
                api.appleIdConnect(this.sid, resp.authorization.id_token, decode.sub, decode.email, '').then(this.onLogin.bind(this))
            });
        },
        googleLogin(resp) {
            //console.log("init google client callback:")
            //console.log(resp);
            api.googleConnect(this.sid, resp.code).then(this.onLogin.bind(this));
        },
        guestLogin(userID) {
            // 10210099550601467
            api.guestLogin(this.sid, userID).then((resp) => {
                //console.log("guest login:", resp)
                localStorage.setItem("userID", userID);
                this.onLogin(resp);
            })
        },
        onLogin(resp) {
            if (resp.data.status === "ok") {
                let data = resp.data;
                // 处理用户数据
                this._global.user = {
                    userID: data.user_id,
                    coins: data.coins,
                    chips: data.chips,
                    username: data.name,
                    lang: data.lang,
                    avatar: data.pic
                };
                localStorage.setItem("userinfo", JSON.stringify(this._global.user));
                this._i18n.locale = /(en)|(es)|(pt)/.test(data.lang) ? data.lang: 'en';
                this.getProductsList();
            } else {
                if (this.$refs.page && this.$refs.page.showTip) {
                    switch(resp.data.error_code) {
                        case "1002": this.$refs.page.showTip(this.$t("message.err_1002"));break;
                        case "1003": this.$refs.page.showTip(this.$t("message.err_1003"));break;
                        default: break;
                    }
                }
                this.logout();
            }
        },
        loginFailed() {
            this.$refs.page && this.$refs.page.showTip && this.$refs.page.showTip(this.$t("message.err_0001"));
        },
        getProductsList() {
            var url = window.location.href;
            var urlObj = new URL(url);
            var bonusId = urlObj.searchParams.get("bonus_id");
            //console.log(this.sid);

            api.getProductList(this.sid, this._global.user.userID, bonusId).then((resp) => {
                this._global.airdrop=resp.data && resp.data.air_drop ? resp.data.air_drop : [];
                this._global.extra = {
                    coins: 0,
                    chips: 0,
                    bonus: 0,
                    bonus_id: 0,
                    bonus_type: '',
                    /*bonus_id: 15,
                    bonus: 500,
                    bonus_type: 'chips',*/
                    bonus_status: ''
                };
                this._global.products = {
                    banners: [],
                    bundles: [],
                    coins: [],
                    chips: []
                };
                this._global.poList = [];

                if (resp.data.loyalty) {
                    this._global.loyalty = resp.data.loyalty;
                }
                if(resp.data.vip_store){
                    this._global.vip_store = resp.data.vip_store;
                    this._global.extra.coins = resp.data.vip_store.vip_level ? Number(resp.data.vip_store.privileges[resp.data.vip_store.vip_level].purchase_coins_x) * 100 : 0;
                    this._global.extra.chips = resp.data.vip_store.vip_level ? Number(resp.data.vip_store.privileges[resp.data.vip_store.vip_level].purchase_chips_x) * 100 : 0;
                }

                let retainDecimals = (num) => {
                    if (/\./.test(Number(num).toString())) {
                        return Math.floor(num) + "." + (Math.round(num * 100) % 100).toString().padEnd(2, "0");
                    } else return num.toString() + ".00"
                }

                resp.data.list && resp.data.list.map((o) => {
                    switch(o.type) {
                        case "web_popup":
                            let art = o.art.filter((a) => a.lang.toString().toLowerCase() === this._i18n.locale);
                            if (art && art.length > 0) {
                                this._global.products.banners.push({
                                    "src": art[0].file.file_id_html5
                                });
                            };
                            break;
                        case "web_bank":
                            o.products.map((p) => {
                                let product = {
                                    "price": retainDecimals(Number(p.price) * Number(p.exchange_rate)),
                                    "hash": p.hash,
                                    "currency": p.currency,
                                    "points": Math.round(Number(p.add_loyalty_point)),
                                    "bp": Math.round(Number(p.bp))
                                };
                                if (p.items && p.items.length > 0) {
                                    product["coins"] = Number(p.items[0]["after_discount_coins"] || 0);
                                    product["extra"] = this._global.extra.coins;
                                    product["coins"] && this._global.products.coins.push(product)
                                }
                            });
                            break;
                        case "web_chipbank":
                            o.products.map((p) => {
                                let product = {
                                    "price": retainDecimals(Number(p.price) * Number(p.exchange_rate)),
                                    "hash": p.hash,
                                    "currency": p.currency,
                                    "points": Math.round(Number(p.add_loyalty_point)),
                                    "bp": Math.round(Number(p.bp))
                                };
                                if (p.items && p.items.length > 0) {
                                    product["chips"] = Number(p.items[0]["after_discount_chips"] || 0);
                                    product["extra"] = this._global.extra.chips;
                                    product["chips"] && this._global.products.chips.push(product)
                                }
                            });
                            break;
                        case "web_po":
                            o.products.map((p) => {
                                let product = {
                                    "price": retainDecimals(Number(p.price) * Number(p.exchange_rate)),
                                    "hash": p.hash,
                                    "currency": p.currency,
                                    "points": Math.round(Number(p.add_loyalty_point)),
                                    "bp": Math.round(Number(p.bp))
                                };
                                let art = o.art.filter((a) => a.lang.toString().toLowerCase() === this._i18n.locale);
                                if (art && art.length > 0) {
                                    product["art"] = art[0].file.file_id_html5;

                                    if (p.items.length > 0) {
                                        p.items.map((i) => {
                                            if (i.type === "wheel" ) {
                                                product["wheel"] = true;
                                                if (i.black_wedge_index && i.black_wedge_index.length > 0) {
                                                    product["wheel"] = false;
                                                    product["blackwheel"] = true;
                                                }
                                            } else {
                                                product[i.type] = i["after_discount_" + i.type];
                                                if (i.type === "coins") product["extra"] = this._global.extra.coins;
                                                else !product["extra"] && (product["extra"] = this._global.extra.chips);
                                            }
                                        });
                                        this._global.products.bundles.push(product);
                                    }
                                }
                            })
                            break;
                        case "web_two_po":
                        case "web_three_po":
                        case "web_rolling_po":
                            let po = {
                                "name": o.name.replace(/-/g, '_'),
                                "type": o.type,
                                "products": [],
                                "extra": this._global.extra.coins || this._global.extra.chips || 0
                            };
                            // https://s3.amazonaws.com/doctor-bingo-staging/assets/external_contents/two_po_test/
                            let arts = o.art.filter((a) => a.lang.toString().toLowerCase() === this._i18n.locale);
                            if (arts && arts.length > 0) {
                                po["art"] = arts[0].file.file_id_html5;
                                // 请求po配置文件
                                api.requestDynamicPoConfig(po["art"] + "config.json?t=" + Date.now()).then((resp) => {
                                    resp.data && (po["config"] = resp.data);
                                    if (po["config"].background && po["config"].background[this._i18n.locale]) {
                                        let background = po["art"] + po["config"].background[this._i18n.locale];
                                        this._global.poAssets.indexOf(background) === -1 && this._global.poAssets.push(background);
                                    }

                                    po["config"].products.map((prodConfig) => {
                                        // 设置要加载的po资源
                                        for (let assetKey in prodConfig) {
                                            if (typeof assetKey !== "undefined" && typeof prodConfig[assetKey].icon !== 'undefined') {
                                                let assetName = po["art"] + prodConfig[assetKey].icon;
                                                assetName && this._global.poAssets.indexOf(assetName) === -1 && this._global.poAssets.push(assetName);
                                            }
                                        }
                                    })

                                    o.products.map((p) => {
                                        let product = {
                                            "isFree": p["is_free"],
                                            "isLocked": p["is_locked"],
                                            "pictureLocked": p["is_picture_locked"],
                                            "purchased": p["is_purchased"],
                                            "rewardLock": p["is_reward_locked"],
                                            "hash": p.hash,
                                            "currency": p.currency,
                                            "price": retainDecimals(Number(p.price) * Number(p.exchange_rate)),
                                            "points": Math.round(Number(p.add_loyalty_point)),
                                            "bp": Math.round(Number(p.bp)),
                                            "items": {}
                                        };
                                        p.items.map((i) => {
                                            if (i.type === "wheel" ) {
                                                product.items["wheel"] = true;
                                                if (i.black_wedge_index && i.black_wedge_index.length > 0) {
                                                    product.items["wheel"] = false;
                                                    product.items["blackwheel"] = true;
                                                }
                                            } else {
                                                product.items[i.type] = i["after_discount_" + i.type];
                                            }
                                        })
                                        po.products.push(product);
                                    })
                                    if (o.type === "web_rolling_po") {
                                        po.purchaseLimit = o["ro_limit_purchase_count"] ? Number(o["ro_limit_purchase_count"]): -1;
                                        for (let i = 0; i < po.products.length - 1; i++) {
                                            if (po.products[i].purchased) {
                                                if (po.products[i + 1] && !po.products[i + 1].purchased) {
                                                    po.products[i + 1].isLocked = false;
                                                    break;
                                                }
                                            }
                                        }
                                    } else {
                                        for (let i = 0; i < po.products.length; i++) {
                                            po.products[i].purchased = po.products[i].isLocked = false;
                                        }
                                    }

                                    //po['art'] = 'http://localhost:8081/src/assets/images/three_po/';
                                    if (o.type !== "web_rolling_po" || po.purchaseLimit !== 0) this._global.poList.push(po);
                                    //console.log(o.type, this._global.poList);
                                })
                                // po["config"] = await import("./assets/config/two_po.json");
                                // po["config"].products.map((prodConfig) => {
                                //     // 设置要加载的po资源
                                //     for (let assetKey in prodConfig) {
                                //         if (typeof assetKey !== "undefined") {
                                //             this._global.poAssets.indexOf(assetKey) === -1 && this._global.poAssets.push(assetKey);
                                //         }
                                //     }
                                // })
                            }
                            break;
                        case 'bonus':
                            this._global.extra.bonus = o.bonus_amount;
                            this._global.extra.bonus_id = o.bonus_id;
                            this._global.extra.bonus_type = o.bonus_type;
                            this._global.extra.bonus_status = o.bonuses_status != undefined ? o.bonuses_status : '';
                            /*this._global.extra.bonus = 500;
                            this._global.extra.bonus_id = 'abc';
                            this._global.extra.bonus_type = 'chips';*/
                            break;
                        default: break;
                    }
                })

                // 排序
                this._global.products.coins.sort((a, b) => a.coins > b.coins ? 1: -1);
                this._global.products.chips.sort((a, b) => a.chips > b.chips ? 1: -1);

                this.$router.replace("/lazyload");
            })
        },
        logout() {
            api.logOut(this.sid).then((resp) => {
                if (resp.data.status === 'ok') {
                    localStorage.removeItem("userID");
                    localStorage.removeItem("userinfo");
                    this._global.user = null;
                    this._global.products = null;
                    this._global.loyalty = null;
                    this._global.vip_store = null;
                    this.$router.replace("/login");
                }
            })
        }
    },

    components: {

    }
}
</script>

<style lang="scss" scoped >
@import './assets/css/common.css';
#app {
    position: relative;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue